/**
 * Переводы: русский.
 *
 * ⚠️ КЛЮЧИ ОБЯЗАНЫ СОВПАДАТЬ ВО ВСЕХ ЧЕТЫРЁХ ЯЗЫКАХ. Пропущенный ключ не
 * ломает сборку и не роняет игру — на экране просто появляется сам ключ
 * вида «menu.shop_sell», и заметить это можно только глазами и только на
 * том языке, на котором никто не играет. Проверка парности — в index.ts
 * этой папки.
 *
 * ⚠️ РАЗДЕЛЕНО ПО ЯЗЫКАМ, А НЕ ПО РАЗДЕЛАМ ИГРЫ. Раздел («меню», «снасть»)
 * при переводе не нужен: переводчик работает с одним языком целиком, а
 * править разом четыре языка приходится только при добавлении ключа — и
 * тогда четыре файла рядом удобнее, чем четыре места в файле на 1845 строк.
 */
import { ТОВАРЫ_RU } from './goods-ru.js';
import { РЫБЫ_RU } from './species-north-ru.js';
import { МИР_RU } from './species-world-ru.js';

export const ru: Record<string, string> = {
  'fish.unknown': 'Рыба на крючке',
  ...ТОВАРЫ_RU,
  ...РЫБЫ_RU,
  ...МИР_RU,
  'hud.anglers_online': 'Рыбаков онлайн: {n}',
  'loader.ключ': 'Проверяю билет',
  'loader.база': 'Открываю журнал',
  'loader.движок': 'Разматываю катушку',
  'loader.сцена': 'Собираю снасть',
  'loader.локация': 'Иду к воде',
  'loader.берег': 'Выбираю место',
  'auth.subtitle': 'Вход в игру',
  'auth.tab_login': 'Вход',
  'auth.tab_register': 'Регистрация',
  'auth.name': 'Имя',
  'auth.name_hold': 'Как вас звать на воде',
  'auth.name_hint': 'Другие игроки будут видеть это имя',
  'auth.email': 'Почта',
  'auth.email_hint': 'Вашу почту никто не увидит — это приватные сведения',
  'auth.password': 'Пароль',
  'auth.pass_hint': 'Только латиница, обязательны цифра и заглавная буква',
  'auth.password2': 'Повторите пароль',
  'auth.pass2_hint': 'Второй раз — чтобы опечатка не заперла вход',
  'auth.login_btn': 'Войти',
  'auth.register_btn': 'Создать аккаунт',
  'auth.pass_min': 'Минимум 6 символов',
  'set.terrain_range': 'Дальность рельефа',
  'set.terrain_range_hint': 'Самое сильное влияние на кадр: рельеф занимает больше половины',
  'set.range_near': 'Ближняя',
  'set.range_normal': 'Обычная',
  'set.range_far': 'Дальняя',
  'set.antialias': 'Сглаживание',
  'set.antialias_hint': 'Убирает квадратики от растяжения и ступеньки на краях; платится пикселями',
  'set.aa_off': 'Откл',
  'set.aa_soft': 'Мягкое',
  'set.aa_full': 'Полное',
  'set.render_scale': 'Масштаб отрисовки',
  'set.render_scale_hint': 'Главный рычаг кадра: меньше — резко быстрее, но мягче картинка',
  'set.fish_distance': 'Дальность прибрежной рыбы',
  'set.fish_distance_hint': 'Дальше этой черты рыба не рисуется',
  'set.vol_tackle': 'Снасть',
  'set.vol_steps': 'Шаги',
  'set.zoom': 'Крупность',
  'set.zoom_hint': 'Сужает обзор: предметы в кадре крупнее',
  'set.lang': 'Язык',
  'set.lang_ru': 'Русский',
  'set.lang_en': 'English',
  'set.lang_uk': 'Українська',
  'set.lang_es': 'Español',
  'lobby.settings': 'Настройки',
  'lobby.min_level': 'Доступно с {level} уровня',
  'set.tab_sound': 'Звук',
  'set.tab_lang': 'Язык',
  'set.tab_account': 'Аккаунт',
  'set.vol_music': 'Музыка',
  'set.vol_effects': 'Звуки меню',
  'set.vol_note': 'Громкость сохраняется на этом устройстве и не переносится на другое.',
  'unit.kg': 'кг',
  'unit.cm': 'см',
  'unit.m': 'м',
  'unit.g': 'г',
  'unit.mm': 'мм',
  'unit.coins': 'мон.',
  // ── Снаряжение и магазин ──
  'slot.rod': 'Удилище',
  'slot.reel': 'Катушка',
  'slot.line': 'Леска',
  'slot.lure': 'Приманка',
  'menu.gear': 'Инвентарь',
  'menu.shop': 'Садок',
  'menu.shop_sell': 'Садок',
  'keepnet.open_hint': 'Садок — нажми, чтобы открыть',
  'keepnet.title': 'Садок',
  'keepnet.full_warn': 'Садок полон — вернись на базу',
  'menu.shop_buy': 'Снасти',
  'menu.level': 'Уровень',
  'menu.max_level': 'предел',
  'menu.worn': 'надето',
  'menu.owned': 'куплено',
  'menu.need_level': 'нужен уровень',
  'menu.slot_empty': 'Пусто',
  'menu.keepnet_empty': 'В садке пусто — половите рыбы',
  'menu.sell': 'Продать',
  'menu.sell_all': 'Отметить всё',
  'menu.sell_pick': 'Выберите рыбу',
  'menu.selling': 'Продаю…',
  'hud.caught_xp': '+{xp} опыта',
  'hud.catch_rejected': 'Улов не записан',
  // ── Меню игры ──
  'menu.button': 'Меню',
  'menu.title': 'Меню',
  'menu.resume': 'Продолжить',
  'menu.locations': 'Локации',
  'menu.records': 'Рекорды',
  'menu.mine': 'Мои уловы',
  'menu.settings': 'Настройки',
  'menu.controls': 'Управление',
  'menu.logout': 'Выйти из учётной записи',
  'menu.graphics': 'Изображение',
  'menu.sound': 'Звук',
  'menu.game': 'Игра',
  'menu.quality': 'Качество',
  'menu.preset_low': 'Низкое',
  'menu.preset_medium': 'Среднее',
  'menu.preset_high': 'Высокое',
  'menu.preset_custom': 'настройки изменены вручную',
  'menu.reset': 'Сбросить раздел',
  'menu.on': 'вкл',
  'menu.off': 'выкл',
  'menu.needs_reload': 'применится после перезапуска',
  'menu.loading': 'Загружаю…',
  'menu.server_off': 'Сервер не отвечает',
  'menu.no_locations': 'Локаций пока нет',
  'menu.no_catches': 'Пока пусто',
  'menu.need_login': 'Нужен вход',
  'menu.you_are_here': 'вы здесь',
  'menu.ctl_move': 'Ходьба',
  'menu.ctl_run': 'Бег',
  'menu.ctl_jump': 'Прыжок',
  'menu.ctl_cast': 'Заброс',
  'menu.ctl_reel': 'Подмотка',
  'menu.ctl_menu': 'Меню',
  'ui.unit_ms': 'мс',
  'ui.unit_mps': 'м/с',
  'ui.unit_beaufort': 'балл',
  'ui.stat_line_reserve': 'ЗАПАС ЛЕСКИ',
  'ui.stat_drag': 'ФРИКЦИОН',
  'ui.stat_reel': 'ПОДМОТКА',
  'ui.make_on': 'Стройка ВКЛ',
  'ui.make_off': 'Стройка выкл',
  'ui.ready_to_cast': 'К ЗАБРОСУ ГОТОВ',
  'state.has_edits': 'есть правки — нажми «Пересоздать»',
  'state.world_built': 'мир собран',
  'state.rebuilding': 'пересобираю…',
  'rhumb.С': 'С',
  'rhumb.ССВ': 'ССВ',
  'rhumb.СВ': 'СВ',
  'rhumb.ВСВ': 'ВСВ',
  'rhumb.В': 'В',
  'rhumb.ВЮВ': 'ВЮВ',
  'rhumb.ЮВ': 'ЮВ',
  'rhumb.ЮЮВ': 'ЮЮВ',
  'rhumb.Ю': 'Ю',
  'rhumb.ЮЮЗ': 'ЮЮЗ',
  'rhumb.ЮЗ': 'ЮЗ',
  'rhumb.ЗЮЗ': 'ЗЮЗ',
  'rhumb.З': 'З',
  'rhumb.ЗСЗ': 'ЗСЗ',
  'rhumb.СЗ': 'СЗ',
  'rhumb.ССЗ': 'ССЗ',
  'ui.title': 'InterFishing v.1.0',
  'ui.gen_brush': 'Радиус кисти',
  'ui.gen_lift': 'Шаг за нажатие',
  'ui.sec_place': 'Что ставим',
  'ui.btn_tree': 'Дерево',
  'ui.btn_bush': 'Куст',
  'ui.btn_grass': 'Трава',
  'ui.btn_rock': 'Камень',
  'ui.btn_reed': 'Камыш',
  'ui.btn_weed': 'Водоросли',
  'ui.btn_erase': 'Стереть в круге',
  'ui.btn_loadmap': 'Загрузить карту',
  'ui.btn_savemap': 'Сохранить карту',
  'ui.btn_sizeup': 'Размер +',
  'ui.btn_sizedown': 'Размер −',
  'ui.help_make':
    'Наведи взгляд на землю — жёлтое кольцо покажет, куда ляжет правка.\n    <kbd>Q</kbd> ниже · <kbd>E</kbd> выше · <kbd>Z</kbd> отменить.\n    Во включённой стройке <kbd>ЛКМ</kbd> повторяет последнее действие,\n    а заброс не работает.<br />\n    Правки и предметы уходят в файл вместе с миром и переживают\n    «Пересоздать»: они лежат в мировых координатах, а не в чанках.',
  'ui.help_play':
    '<kbd>W</kbd><kbd>A</kbd><kbd>S</kbd><kbd>D</kbd> идти · <kbd>Shift</kbd> бегом ·\n    <kbd>ЛКМ</kbd> смотреть<br />\n    <b>Заброс замахом:</b> зажать <kbd>ЛКМ</kbd>, мышь <b>на себя</b>, затем\n    <b>резко от себя</b>.<br />\n    <b>Заброс по нажатию:</b> держать <kbd>ЛКМ</kbd> — кольцо набирает силу,\n    отпустить — летит. <b>Красное</b> кольцо: перебор, уйдёт под ноги.<br />\n    На воде <kbd>ЛКМ</kbd> — подмотка.',
  'ui.unit_kg': 'кг',
  'ui.unit_cm': 'см',
  'ui.unit_g': 'г',
  'ui.unit_m': 'м',
  'ui.unit_mm': 'мм',
  'ui.tab_world': 'Мир',
  'ui.tab_gen': 'Создатель',
  'ui.tab_make': 'Стройка',
  'ui.btn_collapse': 'Свернуть',
  'ui.stat_chunks': 'Чанков',
  'ui.stat_queue': 'В очереди',
  'ui.stat_gen': 'Генерация',
  'ui.stat_tris': 'Треугольников',
  'ui.stat_fps': 'Кадр',
  'ui.stat_pos': 'Позиция',
  'ui.stat_alt': 'Высота',
  'ui.stat_seed': 'Сид',
  'ui.ctl_zoom': 'Крупность',
  'ui.sec_weather': 'Небо и погода',
  'ui.stat_sun': 'Солнце',
  'ui.stat_sunrise': 'Восход',
  'ui.stat_sunset': 'Заход',
  'ui.stat_daylen': 'Долгота дня',
  'ui.stat_vis': 'Видимость',
  'ui.stat_wind': 'Ветер',
  'ui.stat_wave': 'Волна',
  'ui.ctl_time': 'Время',
  'ui.ctl_weather': 'Погода',
  'ui.val_clear': 'ясно',
  'ui.ctl_force': 'Сила',
  'ui.btn_clock': 'Часы идут',
  'ui.btn_wauto': 'Погода сама',
  'ui.sec_tackle': 'Снасть',
  'ui.stat_cast': 'Заброс',
  'ui.stat_tension': 'Натяжение',
  'ui.stat_horizon': 'Горизонт',
  'ui.stat_depth': 'Глубина',
  'ui.stat_tip': 'Вершинка',
  'ui.stat_fish': 'Рыба',
  'ui.sec_lure': 'Приманка',
  'ui.ctl_kind': 'Вид',
  'ui.val_spoon': 'колебалка',
  'ui.ctl_weight': 'Вес',
  'ui.ctl_dive': 'Заглубление',
  'ui.ctl_bitex': 'Клёв ×',
  'ui.sec_line': 'Леска',
  'ui.ctl_mat': 'Материал',
  'ui.val_mono': 'монофил',
  'ui.ctl_dia': 'Диаметр',
  'ui.stat_break': 'Разрыв',
  'ui.sec_rod': 'Удилище',
  'ui.ctl_class': 'Класс',
  'ui.val_medium': 'медиум',
  'ui.ctl_len': 'Длина',
  'ui.ctl_test': 'Тест',
  'ui.ctl_action': 'Строй',
  'ui.val_mid': 'средний',
  'ui.sec_rodpose': 'Посадка удилища',
  'ui.btn_tune': 'Регулировать',
  'ui.btn_std': 'Стандарт',
  'ui.btn_reset': 'Сброс',
  'ui.btn_sizedn': 'Размер −',
  'ui.stat_pose': 'Посадка',
  'ui.sec_reelpose': 'Посадка катушки',
  'ui.btn_setup': 'Настроить',
  'ui.btn_save': 'Сохранить',
  'ui.btn_mode_reel': 'Режим: Катушка',
  'ui.sec_castmode': 'Способ заброса',
  'ui.btn_swing': 'Замахом',
  'ui.btn_newline': 'Новая леска',
  'ui.btn_shore': 'На берег',
  'ui.btn_newseed': 'Новый сид',
  'ui.tr_caught': 'Поймана',
  'ui.btn_ok': 'ОК',
  'ui.language': 'Язык',
  'state.high': 'высоко над водой — подойди к воде',
  'state.reel_long': 'домотка длинного свеса',
  'state.click_water': 'нажатие на воде',
  'state.click': 'нажатие',
  'state.no_swing': 'отпустили без взмаха',
  'state.reel_hang': 'подмотка: приманка висит',
  'state.reel_water': 'подмотка: приманка на воде',
  'state.release': 'отпустил',
  'state.line_end': 'кончилась леска',
  'state.line_break': 'обрыв на {kg} кг',
  'state.came_off': 'снялась',
  'state.hooked_reel': 'села на подмотке {kind}',
  'state.strike': 'подсечка {kind} {kg} кг',
  'state.strike_slack': 'подсечка по слабине',
  'state.hooked_auto': 'села сама {kind} {kg} кг',
  'state.spit': 'выплюнула',
  'state.bite': 'поклёвка {kind} {kg} кг',
  'state.attack': 'атака рыбы',
  'state.attack_school': 'атака стайной {kind} {kg} кг',
  'state.jump': 'свечка',
  'state.lost_tear': 'порвала губу — фрикцион туго',
  'state.lost_slack': 'сошла на слабине',
  'state.lost_jump': 'стряхнула на свечке',
  'state.beached': 'рыба на берегу',
  'state.landed': 'взята {kg} кг',
  'state.lost_why': 'сход: {why}',
  'state.lost_swing': 'сход на взмахе',
  'state.splash': 'приводнение',
  'state.reeled_slack': 'домотано до свеса',
  'state.reset': 'полный сброс снасти',
  'state.in_air': 'в воздухе',
  'state.on_bottom': 'на дне',
  'state.floating': 'на плаву',
  'state.in_water': 'в толще',
  'hud.tab.world': 'МИР',
  'hud.tab.generator': 'ГЕНЕРАТОР',
  'hud.tab.creator': 'СОЗДАТЕЛЬ',
  'hud.sec.map': 'КАРТА',
  'hud.sec.sky': 'НЕБО И ПОГОДА',
  'hud.sec.tackle': 'СНАСТЬ',
  'hud.sec.lure': 'ПРИМАНКА',
  'hud.sec.line': 'ЛЕСКА',
  'hud.sec.rod': 'УДИЛИЩЕ',
  'hud.sec.rodPose': 'ПОСАДКА УДИЛИЩА',
  'hud.sec.reelPose': 'ПОСАДКА КАТУШКИ',
  'map.chunks': 'Чанков',
  'map.generation': 'Генерация',
  'map.frame': 'Кадр',
  'map.height': 'Высота',
  'map.seed': 'Сид',
  'map.position': 'Позиция',
  'map.scale': 'Крупность',
  'map.inQueue': 'В очереди',
  'map.triangles': 'Треугольников',
  'sky.sun': 'Солнце',
  'sky.sunrise': 'Восход',
  'sky.sunset': 'Заход',
  'sky.dayLength': 'Долгота дня',
  'sky.visibility': 'Видимость',
  'sky.wind': 'Ветер',
  'sky.wave': 'Волна',
  'sky.time': 'Время',
  'sky.weather': 'Погода',
  'sky.strength': 'Сила',
  'sky.clockRunning': 'Часы идут',
  'sky.weatherAuto': 'Погода сама',
  'weather.clear': 'ясно',
  'weather.cloudy': 'облачно',
  'weather.fog': 'туман',
  'weather.rain': 'дождь',
  'sun.behind': 'за спиной',
  'sun.day': 'день',
  'sun.night': 'ночь',
  'tackle.cast': 'Заброс',
  'tackle.depth': 'Горизонт',
  'tackle.rodTip': 'Вершинка',
  'tackle.fish': 'Рыба',
  'tackle.tension': 'Натяжение',
  'tackle.waterDepth': 'Глубина',
  'tackle.ready': 'готов',
  'tackle.floating': 'на плаву',
  'tackle.left': 'влево',
  'tackle.right': 'вправо',
  'lure.kind': 'Вид',
  'lure.weight': 'Вес',
  'lure.diving': 'Заглубление',
  'lure.noLip': 'нет лопасти',
  'lure.spoon': 'колебалка',
  'lure.spinner': 'вертушка',
  'lure.wobbler': 'воблер',
  'lure.jig': 'джиг',
  'line.material': 'Материал',
  'line.diameter': 'Диаметр',
  'line.breaking': 'Разрыв',
  'line.dragTo': 'фрикцион до',
  'line.mono': 'монофил',
  'line.fluoro': 'флюорокарбон',
  'line.braid': 'плетёнка',
  'rod.class': 'Класс',
  'rod.length': 'Длина',
  'rod.test': 'Тест',
  'rod.action': 'Строй',
  'rod.ultralight': 'ультралайт',
  'rod.light': 'лайт',
  'rod.medium': 'медиум',
  'rod.heavy': 'хэви',
  'action.slow': 'медленный',
  'action.medium': 'средний',
  'action.fast': 'быстрый',
  'btn.adjust': 'Регулировать',
  'btn.standard': 'Стандарт',
  'btn.reset': 'Сброс',
  'btn.sizePlus': 'Размер +',
  'btn.sizeMinus': 'Размер -',
  'btn.tune': 'Настроить',
  'btn.cancel': 'Отмена',
  'btn.save': 'Сохранить',
  'outcome.landed': 'Улов',
  'outcome.lost': 'Сход',
  'outcome.break': 'Обрыв',
  'outcome.tackle': 'Снасть',
  'lobby.wiki': 'Энциклопедия',
  'lobby.wiki_sub': 'все виды рыб игры',
  'wiki.who': 'Кто это',
  'wiki.where': 'Где искать',
  'wiki.how': 'На что ловить',
  'wiki.no_rod': 'удочкой не ловится',
  'wiki.when': 'Когда клюёт',
  'wiki.bite': 'Как клюёт',
  'rare.массовая': 'массовая',
  'rare.обычная': 'обычная',
  'rare.нечастая': 'нечастая',
  'rare.редкая': 'редкая',
  'rare.очень_редкая': 'очень редкая',
  'rare.единичная': 'единичная',
  'wiki.water': 'Вода',
  'wiki.spawn': 'Нерест',
  'wiki.water_band': 'от {a} до {b} °C · лучше всего {opt} °C',
  'wiki.teeth': 'режет леску — нужен поводок',
  'act.дневная': 'днём',
  'act.ночная': 'ночью',
  'act.сумеречная': 'на зорях',
  'act.круглосуточная': 'круглые сутки',
  'flow.стоячая': 'стоячая вода',
  'flow.слабое': 'слабое течение',
  'flow.сильное': 'сильное течение',
  'flow.любое': 'любое течение',
  'place.трава': 'трава',
  'place.коряги': 'коряги',
  'place.бровка': 'бровка',
  'place.твёрдое_дно': 'твёрдое дно',
  'place.ил': 'ил',
  'place.камни': 'камни',
  'place.открытая_вода': 'открытая вода',
  'place.поверхность': 'поверхность',
  'place.перекат': 'перекат',
  'place.яма': 'яма',
  'school.одиночка': 'держится одиночкой',
  'school.малая_стая': 'небольшой стайкой',
  'school.большая_стая': 'плотным косяком',
  'wiki.size': 'Обычно {t}, до {max}',
  'wiki.length': 'длина около {n}',
  'wiki.horizon': 'Горизонт {a} – {b} м',
  'wiki.retrieve': 'Проводка {a} – {b} м/с',
  'wiki.window': 'На подсечку {n} с',
  'wiki.strike': 'Подсечка {n} м/с',
  'wiki.k_hard': 'резкая',
  'wiki.k_mid': 'обычная',
  'wiki.k_soft': 'мягкая',
  'mouth.плёночная': 'губа плёнчатая',
  'mouth.тонкогубая': 'губа тонкая',
  'mouth.костистая': 'пасть костистая',
  'mouth.панцирная': 'пасть с клыками',
  'mouth.кожистая': 'губа кожистая',
  'mouth.хрящевая': 'рот-трубка хрящевой',
  'wiki.thick': 'толщина тела {n} см',
  'wiki.soon': 'Ещё не в игре',
  'wiki.soon_note': 'Появится с наполнением игры',
  'wiki.h_top': 'у поверхности',
  'wiki.h_mid': 'в полводы',
  'wiki.h_deep': 'у дна',
  'wiki.s_slow': 'медленная',
  'wiki.s_mid': 'средняя',
  'wiki.s_fast': 'быстрая',
  'wiki.w_short': 'времени мало',
  'wiki.w_ok': 'времени хватает',
  'wiki.f_weak': 'слабая',
  'wiki.f_mid': 'бойкая',
  'wiki.f_strong': 'сильная',
  'wiki.lip_soft': 'губа нежная',
  'wiki.lip_mid': 'губа средняя',
  'wiki.lip_hard': 'губа крепкая',
  'wiki.stamina': 'держится до {n} с',
  'wiki.jump_no': 'не свечит',
  'wiki.jump_rare': 'иногда свечит',
  'wiki.jump_often': 'часто свечит',
  'fam.карповые': 'карповые',
  'fam.лососёвые': 'лососёвые',
  'fam.сиговые': 'сиговые',
  'fam.окунёвые': 'окунёвые',
  'fam.осетровые': 'осетровые',
  'fam.сомовые': 'сомовые',
  'fam.щуковые': 'щуковые',
  'fam.центрарховые': 'центрарховые',
  'fam.бычковые': 'бычковые',
  'fam.вьюновые': 'вьюновые',
  'fam.корюшковые': 'корюшковые',
  'fam.миноговые': 'миноговые',
  'fam.прочие': 'прочие',
  'fam.сельдевые': 'сельдевые',
  'fam.змееголовые': 'змееголовые',
  'fam.панцирниковые': 'панцирниковые',
  'fam.цихловые': 'цихловые',
  'fam.харациновые': 'харациновые',
  'fam.ауховые': 'ауховые окуни',
  'bait.мушка': 'искусственная мушка',
  'bait.ручейник': 'личинка ручейника',
  'bait.икра': 'икра',
  'bait.резка': 'резка рыбы',
  'bait.кузнечик': 'кузнечик',
  'bait.зелень': 'нитчатые водоросли',
  'bait.лягушка': 'лягушка',
  'bait.фрукт': 'фрукты',
  'bait.мясо': 'мясо',
  'bait.хлеб': 'хлеб',
  'bait.червь': 'червь',
  'bait.опарыш': 'опарыш',
  'bait.мотыль': 'мотыль',
  'bait.кукуруза': 'кукуруза',
  'bait.перловка': 'перловка',
  'bait.тесто': 'тесто',
  'bait.горох': 'горох',
  'bait.бойл': 'бойл',
  'bait.пеллетс': 'пеллетс',
  'bait.ракушка': 'ракушка',
  'bait.живец': 'живец',
  'bait.рачок': 'рачок',
  'wiki.ingame': 'В игре',
  'wiki.find': 'Введите название',
  'wiki.nothing': 'Ничего не нашлось',
  'wiki.red': 'Красная книга',
  'wiki.red_note': 'Вид под охраной. Такую рыбу отпускают: в садок она не идёт и не продаётся, но за поимку идёт опыт и отдельная строка в рекордах.',
  'lang.ru': 'RU',
  'lang.en': 'EN',
  'lang.uk': 'UK',
  'lang.es': 'ES',
  'ui.tab_gen_old': 'Генератор',
  'ui.tab_map_title': 'Карта мира: найти настоящий водоём',
  'ui.tab_map': 'Карта',
  'ui.btn_rebuild_title': 'Применить все правки и пересобрать мир заново',
  'ui.btn_rebuild': 'Пересоздать мир',
  'tackle.aim': 'замах',
  'tackle.flying': 'летит',
  'tackle.reeling': 'подмотка',
  'tackle.taut': 'натянута',
  'tackle.slack': 'провис',
  'tackle.overload': 'ПЕРЕГРУЗ',
  'tackle.straight': 'прямой',
  'ui.sec_pond': 'Водоём',
  'ui.sec_edge': 'Бровка',
  'ui.sec_bank': 'Берег',
  'ui.sec_relief': 'Рельеф вокруг',
  'ui.sec_ground': 'Земля',
  'tackle.drag_slipping': 'фрикцион сдаёт',
  'tackle.hold': 'держи',
  'tackle.beached': 'на берегу',
  'tackle.strike_now': 'ПОДСЕКАЙ',
  'ui.btn_done': 'Готово',
  'ui.btn_charge': 'По нажатию',
  'reel.mode_body': 'Режим: Корпус',
  'reel.mode_crank': 'Режим: Ручка',
  'reel.mode_bail': 'Режим: Скоба',
  'reel.mode_line': 'Режим: Точка лески',
  'state.world_built_already': 'мир уже собран по этим числам',
  'ui.unit_km': 'км',
  'map.search_placeholder': 'Найти водоём по названию…',
  'map.search_btn': 'Искать',
  'map.close_title': 'Закрыть (Esc)',
  'map.attribution': '© участники OpenStreetMap',
  'map.zoom': 'приближение',
  'map.status_searching': 'ищу…',
  'map.status_error': 'не вышло: {err}',
  'map.status_empty': 'ничего не нашлось',
  'map.status_found': 'нашлось {n}',
  'map.status_network': 'нет сети: {err}',
  'minimap.tooltip': 'Карта водоёма. Щелчок — открыть во весь экран',
  'minimap.header': 'Карта',
  'minimap.close_title': 'Закрыть · Esc',
  'minimap.zoom_in': 'Приблизить',
  'minimap.zoom_out': 'Отдалить',
  'minimap.across': 'всего {n} км поперёк',
  'minimap.legend_player': 'рыболов',
  'minimap.legend_barrier': 'граница, дальше не уйти',
  'minimap.legend_depth': 'числа — глубина, м',
  'lure.no_lip': 'нет лопасти',
  'tackle.drag_up_to': 'фрикцион до',
  'ui.status_saving': 'пишем…',
  'ui.status_saved': 'переписан',
  'ui.status_save_err': 'не записать: нет сервера разработки',
  'ui.status_reset': 'сброшен',
  'ui.status_err': 'ошибка записи',
  'ui.status_aim_ground': 'наведи на землю',
  'wind.calm': 'штиль',
  'wind.light_air': 'тихий',
  'wind.light_breeze': 'лёгкий',
  'wind.gentle_breeze': 'слабый',
  'wind.moderate_breeze': 'умеренный',
  'wind.fresh_breeze': 'свежий',
  'wind.strong_breeze': 'сильный',
  'wind.near_gale': 'крепкий',
  'wind.gale': 'шторм',
  'sun.dawn': 'рассвет',
  'sun.dusk': 'закат',
  'sun.morning': 'утро',
  'sun.evening': 'вечер',
  'sun.rel_face': 'в лицо',
  'sun.rel_back': 'со спины',
  'sun.rel_side': 'сбоку',
  'sun.rel_below': 'за горизонтом',
  'load.release_drag': 'ОТПУСТИ ФРИКЦИОН',
  'load.charge_over': 'ПЕРЕБОР · ЗАБРОС УЙДЁТ ПОД НОГИ',
  'load.charge_hold': 'НАБОР · ОТПУСТИ ДЛЯ ЗАБРОСА',
  'load.aim_swing': 'ЗАМАХ · ВЕДИ УДИЛИЩЕМ',
  'load.trophy_hold': 'РЫБА В РУКАХ · ОТПУСТИ ЕЁ',
  'load.line_broken': 'ЛЕСКА ОБОРВАНА · ПРИВЯЖИ НОВУЮ',
  'load.long_hang': 'ДЛИННЫЙ СВЕС · ДОМОТАЙ',
  'load.high_above_water': 'ВЫСОКО НАД ВОДОЙ · ПОДОЙДИ К ВОДЕ',
  'load.fish_nearby': 'РЯДОМ РЫБА · ОПУСТИ НАЖИВКУ',
  'load.ready': 'К ЗАБРОСУ ГОТОВ',
  'load.landed': 'В САДОК',
  'load.lost': 'СХОД',
  'load.sagging': 'СЛАБИНА — КРУТИ!',
  'load.biting': 'ПОКЛЁВКА — ПОДСЕКАЙ!',
  'load.beached': 'НА БЕРЕГУ · СМАТЫВАЙ',
  'load.overload': 'ПЕРЕГРУЗ · ОТПУСТИ ФРИКЦИОН',
  'load.cast_dist': 'дальность {m} м',
  'load.depth': 'глубина {m} м',
  'load.bite_rate': 'шанс {p}%',
  'reel_dial.drag': 'ФРИКЦИОН',
  'reel_dial.reel': 'СКОРОСТЬ',
  'line_dial.break': 'РАЗРЫВНАЯ',
  'line_dial.left': 'ЗАПАС ЛЕСКИ',
  'line_dial.broken': 'обрыв',

  // ── Счёт: формы числа. Их выбирает Intl.PluralRules, см. i18n.ts ──────
  'count.fish_few': '{n} рыбы',
  'count.fish_many': '{n} рыб',
  'count.fish_one': '{n} рыба',
  'count.fish_other': '{n} рыб',
  'count.species_few': '{n} вида',
  'count.species_many': '{n} видов',
  'count.species_one': '{n} вид',
  'count.species_other': '{n} видов',
  'count.records_few': '{n} записи',
  'count.records_many': '{n} записей',
  'count.records_one': '{n} запись',
  'count.records_other': '{n} записей',
  'count.items_few': '{n} предмета',
  'count.items_many': '{n} предметов',
  'count.items_one': '{n} предмет',
  'count.items_other': '{n} предметов',
  'count.waters_few': '{n} водоёма',
  'count.waters_many': '{n} водоёмов',
  'count.waters_one': '{n} водоём',
  'count.waters_other': '{n} водоёмов',

  // ── Рыболовная база: лобби ────────────────────────────────────────────
  'lobby.waters': 'Водоёмы',
  'lobby.waters_sub': 'выбери, куда поедешь',
  'lobby.all_list': 'Весь список',
  'lobby.world_map': 'Карта Мира',
  'lobby.all_list_hint': 'Все страны и водоёмы одним списком',
  'lobby.go': 'На рыбалку',
  'lobby.no_country': 'Без страны',
  'lobby.list_failed': 'Не удалось спросить сервер.',
  'lobby.list_failed_hint':
    'Водоёмы есть, но список не пришёл: игровой сервер не отозвался. Это не пустая база — это оборванная связь.',
  'lobby.empty': 'Водоёмов пока нет.',
  'lobby.empty_admin':
    'Обведи берег по настоящей карте — и он встанет в этот список, а вместе с ним откроется и для всех остальных.',
  'lobby.empty_player':
    'Их размечает администратор по настоящим картам. Загляни позже — первый уже готовится.',
  'lobby.mirror': '{n} км² зеркала',
  'lobby.across': '{n} км в поперечнике',
  'lobby.depth': 'глубина до {n} м',
  'lobby.no_fish': 'рыбы пока нет',
  'lobby.mapped': 'размечен {when}',
  'lobby.base': 'Рыболовная база',
  'lobby.level_short': '{n} ур.',
  'lobby.logout': 'Выход',
  'lobby.trace_new': 'Обвести новый водоём по карте',
  'lobby.keepnet': 'Садок',
  'lobby.empty': 'Водоёмов пока нет.',
  'lobby.empty_admin':
    'Обведи берег по настоящей карте — и он встанет в этот список, а вместе с ним откроется и для всех остальных.',
  'lobby.empty_player':
    'Их размечает администратор по настоящим картам. Загляни позже — первый уже готовится.',
  'lobby.mirror': '{n} км² зеркала',
  'lobby.across': '{n} км в поперечнике',
  'lobby.depth': 'глубина до {n} м',
  'lobby.no_fish': 'рыбы пока нет',
  'lobby.mapped': 'размечен {when}',
  'lobby.base': 'Рыболовная база',
  'lobby.level_short': '{n} ур.',
  'lobby.logout': 'Выход',
  'lobby.trace_new': 'Обвести новый водоём по карте',
  'lobby.keepnet': 'Садок',
  'lobby.keepnet_empty': 'отправляйтесь на рыбалку и поймайте рыбу',
  'lobby.xp': 'Опыт',
  'lobby.wallet': 'Кошелёк',
  'lobby.wallet_info': 'Здесь хранятся ваши монеты. Ловите рыбу, продавайте улов в магазине и покупайте новые снасти, чтобы ловить еще более крупную рыбу!',
  'lobby.xp_line': '{level} уровень. До следующего уровня: {xp} опыта.',
  'lobby.xp_info': 'Каждая пойманная рыба приносит опыт. Чем крупнее и реже улов — тем больше опыта. Повышайте уровень, чтобы открыть новые водоёмы!',
  'lobby.gold': 'Золото',
  'lobby.gold_info': 'Премиум валюта. Позволяет покупать особые снасти и бонусы.',
  'lobby.pack_starter_title': 'Стартовый набор',
  'lobby.pack_starter_desc': '100 Золота<br>250 Опыта<br>1000 Монет',
  'lobby.pack_pro_title': 'Профи набор',
  'lobby.pack_pro_desc': '300 Золота<br>750 Опыта<br>3000 Монет',
  'lobby.pack_master_title': 'Мастер набор',
  'lobby.pack_master_desc': '1000 Золота<br>2000 Опыта<br>10000 Монет',
  'lobby.store_coming_soon': 'Покупки за реальные деньги скоро будут доступны!',
    'lobby.wallet_line': '{coins} монет · {level} уровень, до следующего {xp} опыта',
  'lobby.tackle': 'Рюкзак',
  'lobby.in_hands': 'В руках',
  'lobby.in_bag': 'В рюкзаке',
  'lobby.starter': 'стартовое',
  'lobby.worn_now': 'Надето: {name}',
  'lobby.records': 'Рекорды игроков',
  'lobby.records_none': 'пока никем не поставлены',
  'lobby.mine': 'Мои уловы',
  'lobby.open_wiki': 'открыть в энциклопедии',
  'lobby.mine_none': 'история пока пуста',
  'lobby.no_server': 'сервер не ответил',
  'lobby.shop': 'Магазин',
  'lobby.shop_sub': 'снасти, насадка, снаряжение',
  'shop.sell': 'Продать улов',
  'shop.rod': 'Удилища',
  'shop.reel': 'Катушки',
  'shop.line': 'Лески',
  'shop.leader': 'Поводки',
  'shop.hook': 'Крючки',
  'shop.lure': 'Приманки',
  'shop.fly': 'Нахлыст',
  'shop.bait': 'Наживка',
  'shop.groundbait': 'Прикормка',
  'shop.food': 'Еда',
  'shop.keepnet': 'Садки',
  'shop.sonar': 'Эхолоты',
  'shop.boat': 'Лодки',
  'shop.gear': 'Снаряжение',
  'shop.soon': 'скоро',
  'lobby.shop_coins': 'В кошельке: {coins} мон.',
  'lobby.shop_sell': 'Продать улов',
  'lobby.shop_buy': 'Купить снасть',
  'lobby.shop_sold': 'Продано рыб: {n}',
  'lobby.shop_bought': 'Куплено: {name}',
  'lobby.tours': 'Турниры',
  'lobby.tours_sub': 'соревнования на время и на вес',
  'lobby.club': 'Клуб рыболовов',
  'lobby.club_sub': 'друзья, звания, совместные выезды',
  'lobby.soon': 'скоро',
  'lobby.atlas': 'Куда поедем',
  'lobby.sheet_empty': 'Пока пусто',
  'lobby.close': 'Закрыть',
  'lobby.cancel': 'Отмена',
  'lobby.logout_ask': 'Выйти из учётной записи?',
  'lobby.logout_note': 'Улов и снасти останутся на месте. Чтобы вернуться, понадобится почта и пароль.',
  'lobby.equipped': 'надето · {slot}',
  'lobby.a_fish': 'рыба',
  'lobby.account': 'Учётная запись',
  'lobby.name': 'Имя',
  'lobby.name_hint': 'Это имя видят другие игроки — в рекордах и на водоёме.',
  'lobby.name_save': 'Сохранить имя',
  'lobby.name_done': 'Теперь вас зовут {name}',
  'lobby.pass_new': 'Новый пароль',
  'lobby.pass_min': 'Минимум 6 знаков',
  'lobby.pass_again': 'Повторите пароль',
  'lobby.pass_again_hint': 'Ещё раз',
  'lobby.pass_save': 'Сменить пароль',
  'err.pass_mismatch': 'Пароли не совпадают',
  'lobby.pass_done': 'Пароль сменён. Он понадобится при следующем входе.',
  'lobby.lang': 'Язык игры',
  'lobby.email_note': 'Вход по почте <b>{email}</b>. Её не видит никто, кроме вас.',
  'lobby.account_hint': 'Настройки учётной записи',
  'lobby.water_hint': 'Настройки водоёма',
  'lobby.fish_here': 'Какая рыба здесь водится',
  'lobby.fish_note':
    'Снятый вид перестанет клевать на этом водоёме. У нового водоёма отмечены все — так он сразу пригоден для рыбалки.',
  'lobby.save': 'Сохранить',
  'lobby.fish_saved': 'Сохранено: {list}',
  'lobby.fish_none_saved': 'Водоём оставлен без рыбы',

  // ── Страны: ключ — код по ISO из данных карты, см. lobby.ts ───────────
  'country.ua': 'Украина',
  'country.de': 'Германия',
  'country.it': 'Италия',
  'country.ch': 'Швейцария',
  'country.no': 'Норвегия',
  'country.si': 'Словения',
  'country.fr': 'Франция',
  'country.se': 'Швеция',
  'country.ee': 'Эстония',
  'country.jp': 'Япония',
  'country.es': 'Испания',
  'country.pl': 'Польша',
  'country.lt': 'Литва',
  'country.lv': 'Латвия',
  'country.fi': 'Финляндия',
  'country.cz': 'Чехия',
  'country.at': 'Австрия',
  'country.hu': 'Венгрия',
  'country.ro': 'Румыния',
  'country.gb': 'Великобритания',
  'country.ie': 'Ирландия',
  'country.ca': 'Канада',
  'country.us': 'США',

  'key.lmb': 'ЛКМ',
  'key.rmb': 'ПКМ',

  'menu.tobase': 'Вернуться на базу',
  'menu.tobase_sure': 'Точно? Выйти в Лобби?',

  // ── Отказы сервера. Ключ приезжает рядом с текстом, см. GameError ─────
  'err.fill_all': 'Заполните все поля',
  'err.bad_credentials': 'Неверная почта или пароль',
  'err.bad_email': 'Неверный формат почты',
  'err.short_password': 'Пароль короче шести знаков',
  'err.keepnet_full': 'Садок полон: {cap} рыб. Вернись на базу и продай улов',
  'err.weak_password': 'Пароль не по правилу: нужны латиница, цифра и заглавная буква',
  'err.user_exists': 'Пользователь уже существует',
  'err.nothing_to_sell': 'Нечего продавать',
  'err.already_sold': 'Эта рыба уже продана',
  'err.no_such_item': 'Нет такого предмета',
  'err.not_for_sale': 'Этот предмет не продаётся',
  'err.need_login': 'Нужен вход',
  'err.need_level': 'Нужен уровень {n}',
  'err.not_enough_coins': 'Не хватает монет',
  'err.already_bought': 'Уже куплено',
  'err.wrong_slot': 'Не тот слот',
  'err.item_not_owned': 'Этого предмета у вас нет',
  'err.no_water': 'Не указан водоём',
  'err.no_fish_kinds': 'Не указаны виды рыбы',
  'err.name_required': 'Введите имя',
  'err.name_short': 'Имя короче {n} знаков',
  'err.name_long': 'Имя длиннее {n} знаков',
  'err.name_at': 'В имени не может быть знака @',
  'err.name_taken': 'Это имя уже занято',
  'err.no_account': 'Учётная запись не найдена',
  'err.no_answer': 'Сервер не ответил',

  // ── Администрирование игроков ──
  'adm.players': "Игроки",
  'adm.find': "Имя, почта или IP",
  'adm.more': "Показать ещё",
  'adm.total': "всего: {n}",
  'adm.loading': "гружу…",
  'adm.settings': "Настройки игрока",
  'adm.admin': "админ",
  'adm.player': "игрок",
  'adm.banned': "заблокирован",
  'adm.ok': "в порядке",
  'adm.never': "ни разу",
  'adm.now': "сейчас в игре",
  'adm.min_ago': "{n} мин назад",
  'adm.hour_ago': "{n} ч назад",
  'adm.day_ago': "{n} дн назад",
  'adm.lvl': "ур. {n}",
  'adm.lvl_full': "Уровень",
  'adm.coins': "монет",
  'adm.fish': "рыб",
  'adm.things': "Вещей",
  'adm.role': "Роль",
  'adm.state': "Состояние",
  'adm.registered': "Зарегистрирован",
  'adm.seen': "Последний вход",
  'adm.back': "к списку",
  'adm.give': "Начислить",
  'adm.rename': "Переименовать",
  'adm.newpass': "новый пароль",
  'adm.setpass': "Сменить пароль",
  'adm.reason': "причина",
  'adm.ban': "Заблокировать",
  'adm.unban': "Разблокировать",
  'adm.make_admin': "Сделать админом",
  'adm.make_player': "Разжаловать",
  'adm.last_catches': "Последние уловы",
  'adm.logins': "Входы",
  'adm.failed': "неудача",
  'adm.sure': "Точно?",
  'adm.yes': "Да",

  // ── Гостевой вход ──
  'auth.or': "или",
  'auth.guest': "Гостевой вход",
  'lobby.logout_guest': "Гостевой аккаунт вернуть нельзя: пароля у него нет. Уровень, монеты, садок и рекорды исчезнут насовсем.",
  'lobby.guest_note': "Вы играете гостем. Заведите почту и пароль — весь прогресс останется, а войти можно будет с любого устройства.",
  'lobby.guest_email': "Почта",
  'lobby.guest_save': "Сделать постоянным",
  'lobby.guest_done': "Готово: теперь это постоянный аккаунт",
  'adm.guest': "гость",
  'err.guest_many': "Слишком много гостей с этого адреса. Попробуйте позже",
  'err.not_guest': "Это уже постоянный аккаунт",
  'err.email_taken': "Такая почта уже занята",

  // ── Горячие клавиши ──
  'menu.ctl_gear': "Снасти",
  'menu.ctl_keepnet': "Садок",
  'menu.ctl_map': "Карта",

  // ── Качество картинки ──
  'set.q_max': "Максимум",
  'set.q_mid': "Средне",
  'set.q_min': "Минимум",
  'set.q_off': "Выкл",
  'set.reflection': "Отражение в воде",
  'set.reflection_hint': "Второй проход всей сцены за кадр. Самый дорогой пункт после масштаба: на слабой машине выключение даёт больше, чем всё остальное вместе.",
  'set.shadows': "Тени",
  'set.shadows_hint': "Каскадные тени рисуют мир заново по разу на каскад. Ступень вниз — это на один проход по всем деревьям меньше.",
  'set.vegetation': "Растительность",
  'set.vegetation_hint': "Докуда видно траву, тростник и кусты. Радиус вдвое меньше — работы вчетверо меньше.",

  'set.clouds': "Облака",
  'set.clouds_hint': "Считаются по пикселю неба и повторяются в отражении. Ступени убавляют детальность шума, а не сами облака.",

  'load.bytes': "{done} из {total} МБ · {pct} %",

  'touch.cast': "Заброс",

  'touch.reel': "Подмотка",

  'menu.map': "Карта",

  'loader.мир': "Осматриваюсь",

  'load.bytes_only': "Загружено {done} МБ",
  "load.file_line": "{name} · {size} МБ",
  "load.world_failed": "Водоём не открылся",
  "load.stalled": "Загрузка затянулась",
  "load.back_to_lobby": "Вернуться в журнал",

  'touch.lamp': "Фонарь",

  'set.hand': "Рука со снастью",
  'set.hand_hint': "Левая — кнопки слева, приборы справа. Правая — наоборот",
  'set.hand_left': "Левая",
  'set.hand_right': "Правая",

  'shop.float': "Поплавки",
  'slot.float': "Поплавок",
  'kit.спиннинг': "Спиннинг",
  'kit.удочка': "Удочка",

  'item.cast': "заброс до",

  'reel_dial.depth': 'ГЛУБИНА',
  'rod.float': 'маховая',
  'rod.pole': 'штекерная',
  'rod.bolo': 'болонская',
  'rod.match': 'матчевая',
  'rod.feeder': 'фидерная',
  'load.engine_failed': "Не удалось загрузить игру. Обновите страницу.",
};
